import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ha-mypage l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "メールアドレス 確認", -1)
const _hoisted_3 = { class: "ha__sec ha-mypage__sec" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-messages" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ha-message" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "ha-message__txt ha-message__txt--primary" }, [
      /*#__PURE__*/_createElementVNode("i"),
      /*#__PURE__*/_createElementVNode("span", null, "メールアドレスに届いた確認コードを入力してください。")
    ])
  ])
], -1)
const _hoisted_5 = { class: "p-mypage__field-container" }
const _hoisted_6 = { class: "p-fields p-fields--confirm" }
const _hoisted_7 = { class: "c-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "新しいメールアドレス", -1)
const _hoisted_9 = { class: "c-field__body" }
const _hoisted_10 = { class: "p-errors" }
const _hoisted_11 = { class: "c-error" }
const _hoisted_12 = { class: "p-fields" }
const _hoisted_13 = { class: "c-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "confirmationCode"
}, "確認コード", -1)
const _hoisted_15 = { class: "c-field__body" }
const _hoisted_16 = { class: "c-field__input has-horizontal-item" }
const _hoisted_17 = { class: "ha__txt" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("確認コードが届かない場合は ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "コードを再送する", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "c-field has-submit has-mt" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "更新する", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Form, {
        onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.confirmConfirmationCode, this))),
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(({ errors, meta }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("fieldset", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.newEmailRef), 1)
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errorMsgRef), 1)
            ], 512), [
              [_vShow, _ctx.errorMsgRef]
            ]),
            _createElementVNode("fieldset", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "confirmationCode",
                      name: "confirmationCode",
                      modelValue: _ctx.confirmationCodeRef,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmationCodeRef) = $event)),
                      placeholder: "コードを入力",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.confirmationCode), 513), [
                [_vShow, errors.confirmationCode]
              ]),
              _createElementVNode("p", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.resendAttrConfirmationCode, this))),
                  class: "c-link c-link--primary"
                }, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "ha-btn is-submit",
                  disabled: !meta.valid || _ctx.isDeterringRef
                }, _hoisted_24, 8, _hoisted_22),
                _createElementVNode("button", {
                  type: "button",
                  class: "ha-btn ha-btn--outline",
                  disabled: _ctx.isDeterringRef,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelPassword && _ctx.cancelPassword(...args)))
                }, _hoisted_27, 8, _hoisted_25)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}